import React from 'react'
import Svg, { SvgType } from 'components/svgComponent/Svg'

export default function(props: SvgType) {
  return (
    <Svg width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        d="M8.6563 8.70667L11.9476 5.41334L12.8936 6.34667L8.6563 10.5867L4.41895 6.34667L5.36502 5.41334L8.6563 8.70667Z"
        fill="#D1D5DB"
      />
    </Svg>
  )
}
